// PostHog client-side instrumentation — only active inside iframes (e.g. embedded dashboards)
// Uses dynamic import so the build succeeds even if posthog-js is not installed.

if (typeof window !== 'undefined' && window.self !== window.top) {
  import('posthog-js')
    .then(({ default: posthog }) => {
      posthog.init('phc_oNoyLx73nwdgrC1OMk0cVk8p67aAsO1U9PrhBrqEGwT', {
        api_host: 'https://us.i.posthog.com',
        defaults: '2026-01-30',
        session_recording: {
          recordCrossOriginIframes: true,
        },
      });
    })
    .catch(() => {
      // posthog-js not available — analytics silently disabled
    });
}
